// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import {
  
  QueryClient,
  QueryClientProvider
} from '/Users/liujia/DEV/test-projects/Deroad-website/ERP/frontend/node_modules/@tanstack/react-query';

const reactQueryConfig = {};
const client = new QueryClient(reactQueryConfig.queryClient || {});
export function rootContainer(container) {
  return (
    <QueryClientProvider
      client={client}
      
    >
      {container}
      
    </QueryClientProvider>
  );
}
